import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

type ID = number;
type Subscription = {
  id: ID;
  loading: boolean;
};

@Injectable()
export class DialogLoaderService {
  private subscriptions: Subscription[] = [];
  private loadingSubject = new BehaviorSubject(false)

  loaderState$ = this.loadingSubject.asObservable()
  updatedCount = 0

  subscribe() {
    const sub = this.createSubscription();
    this.subscriptions.push(sub);
    return sub.id;
  }

  unsubscribe(id: ID) {
    this.deleteSubscription(id);
    this.updateSubjectState()
  }

  show(id: ID){
    this.subscriptions[this.getSubscriptionIndex(id)].loading = true;
    this.updateSubjectState()
  }

  hide(id: ID){
    this.subscriptions[this.getSubscriptionIndex(id)].loading = false;
    this.updateSubjectState()
  }

  private updateSubjectState(){
    let subjectState = false
    for(let i = 0; i < this.subscriptions.length; i++){
      if(this.subscriptions[i].loading){
        subjectState = true
        break
      }
    }

    if(subjectState != this.loadingSubject.value){
      this.loadingSubject.next(subjectState)
      this.updatedCount++
    }
  }

  private createSubscription() {
    return {
      id: this.subscriptions.length,
      loading: false,
    };
  }

  private deleteSubscription(id: ID) {
    this.subscriptions.splice(this.getSubscriptionIndex(id));
  }

  private getSubscriptionIndex(id: ID) {
    return this.subscriptions.findIndex((sub) => sub.id == id);
  }
}
